var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDdChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.617 17.924C2.43424 17.8484 2.27804 17.7202 2.1682 17.5557C2.05836 17.3912 1.99982 17.1978 2 17V5C2 4.20435 2.31607 3.44129 2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H15C15.7956 2 16.5587 2.31607 17.1213 2.87868C17.6839 3.44129 18 4.20435 18 5V11.873C18 12.6686 17.6839 13.4317 17.1213 13.9943C16.5587 14.5569 15.7956 14.873 15 14.873H6.538L3.707 17.707C3.56716 17.8469 3.38895 17.9422 3.19492 17.9809C3.0009 18.0195 2.79978 17.9997 2.617 17.924Z",
    fill: "#B2B1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 22C20.7348 21.9999 20.4805 21.8946 20.293 21.707L17.919 19.333H11C10.2046 19.3322 9.44199 19.0159 8.87956 18.4534C8.31712 17.891 8.00079 17.1284 8 16.333V11C8.00079 10.2046 8.31712 9.44199 8.87956 8.87956C9.44199 8.31712 10.2046 8.00079 11 8H19C19.7954 8.00079 20.558 8.31712 21.1204 8.87956C21.6829 9.44199 21.9992 10.2046 22 11V21C22 21.2652 21.8946 21.5196 21.7071 21.7071C21.5196 21.8946 21.2652 22 21 22Z",
    fill: "#6563FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDdChat);
export default __webpack_public_path__ + "static/media/icon-dd-chat.9e592d5929cd9a0d15002f1785d114a4.svg";
export { ForwardRef as ReactComponent };